module.exports = __webpack_public_path__ + "media/images/gift/gift-intro-image-pc-4aff6f5e0a2dad2087ead92a08395fdd.png";